import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
    DragEndEvent,
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    verticalListSortingStrategy,
    useSortable,
} from '@dnd-kit/sortable';
import {
    restrictToVerticalAxis,
    restrictToParentElement,
} from '@dnd-kit/modifiers';
import { CSS } from '@dnd-kit/utilities';
import save from '../../../../assets/router/save.svg';
import {
    Container,
    FormContainer,
    InputDiv,
    InputLabel,
    Input,
    StyledSelect,
    StyledOption,
    StyledDate,
    IframeContainer,
    ButtonOfSection,
    ButtonOfSectionText,
    OptionsDiv,
    StyledLink,
    StyledSearch,
    OptionsContainer,
    StyledFreightText,
    StyledFreight,
    StyledCheckList,
    FreightInfo,
    StyledFreightSubText,
    ContentContainer,
    StyledChecklistContainer,
    ContainerHeader,
    BigText,
    DivComponents,
    ButtonContainer,
    SwitchDiv,
    SwitchBox,
    SwitchInput,
    SwitchSlider,
    SelectData
} from './style'
import SectionContext from "../../../../contexts/SectionContext";
import { Button } from "react-bootstrap";
import { OptionSubText } from "../../../../components/AddStockModal/style";
import {mock} from './utils'
import { RouterContext } from "../../../../contexts/RouterContext";
import axios from "axios";
import { id, ro } from "date-fns/locale";
import { set } from "date-fns";
import  {GoogleMap, Marker, InfoWindow, useLoadScript, DirectionsRenderer, DirectionsService} from '@react-google-maps/api';
import MyMap from './map'
import { RouterInfoContext } from "../../../../contexts/RouterInfoContext";
import { useNavigate, useOutletContext } from "react-router-dom";
import { RouterOutletType } from "../index2";
import { ButtonCreate } from "../../../../components/styles/subheader-style";
import { FeedbackContext } from "../../../../contexts/FeedbackContext";

interface Waypoints  {
  location: string,
  stopover: boolean
}


interface FreightItem {
  id: number;
  company: {
    companyName: string;
  };
  address: {
    street: string;
    number: string;
    neighborhood: {
      city: {
        name: string;
        state: {
          uf: string;
        };
      };
    };
  };
  routeId?: number | null;
}

// Draggable Freight Item Component
const DraggableFreightItem: React.FC<{
  freight: FreightItem;
  onSelect: (id: number, freight: FreightItem) => void;
}> = ({ freight, onSelect }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: freight.id.toString(),
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    >
      <StyledFreight 
        onClick={() => onSelect(freight.id, freight)}
        style={{ 
          cursor: 'grab',
          border: isDragging ? '2px dashed #3b82f6' : undefined,
          backgroundColor: isDragging ? '#f3f4f6' : undefined
        }}
      >
       <StyledChecklistContainer><StyledCheckList className="selected"/></StyledChecklistContainer> 
        <FreightInfo>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <StyledFreightText title={freight.company.companyName}>{freight.company.companyName.split(' ').slice(0, 2).join(' ')}</StyledFreightText>
            {/* <div style={{ 
              fontSize: '12px', 
              color: '#6b7280', 
              backgroundColor: '#e5e7eb', 
              padding: '2px 6px', 
              borderRadius: '4px' 
            }}>
              Arraste para reordenar
            </div> */}
          </div>
          <StyledFreightSubText>
            {`${freight.address.street}, ${freight.address.number} - ${freight.address.neighborhood.city.name}/${freight.address.neighborhood.city.state.uf}`}
          </StyledFreightSubText>
        </FreightInfo>
      </StyledFreight>
    </div>
  );
};

const NewRouter = () => {
    const dataFormatter = (isoDateString: string): string => {
        if (!isoDateString) {
            return ''; // Retorna vazio se a string for nula ou vazia
        }
    
        const dateUtc = new Date(isoDateString);
    
        // Verifica se a data é válida antes de tentar formatar
        if (isNaN(dateUtc.getTime())) {
            console.error("Data ISO inválida recebida:", isoDateString);
            return ''; // Trata o caso de uma string de data inválida
        }
    
        // Extrai as partes da data diretamente do UTC
        const year = dateUtc.getUTCFullYear();
        const month = dateUtc.getUTCMonth() + 1; // getUTCMonth é 0-indexado, então adiciona 1
        const day = dateUtc.getUTCDate();
    
        // Garante que mês e dia tenham dois dígitos (ex: 01 em vez de 1)
        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;
    
        return `${formattedDay}/${formattedMonth}/${year}`;
    };
    const dataFormatterISO = (dateString: string): string => {
        // Verifica se a string de data está no formato esperado (dd/mm/yyyy)
        const parts = dateString.split('/');
        if (parts.length !== 3) {
            console.error("Formato de data inválido. Esperado 'dd/mm/yyyy'. Recebido:", dateString);
            // Ou você pode lançar um erro: throw new Error("Formato de data inválido.");
            return ''; // Retorna uma string vazia ou trata o erro como preferir
        }
    
        const [day, month, year] = parts;
    
        // Constrói um objeto Date em UTC para evitar problemas de fuso horário local
        // Lembre-se que o mês no construtor de Date é 0-indexado (Janeiro = 0, Fevereiro = 1, etc.)
        const dateObject = new Date(
            Date.UTC(parseInt(year), parseInt(month) - 1, parseInt(day))
        );
    
        // Opcional: Validação para datas inválidas (ex: "30/02/2025")
        // Se a data fornecida for inválida, Date.UTC() ainda pode criar um objeto Date,
        // mas com o dia "corrigido" (ex: 30/02 vira 02/03).
        // Esta verificação garante que a data original era logicamente válida.
        if (dateObject.getUTCFullYear() !== parseInt(year) ||
            dateObject.getUTCMonth() !== (parseInt(month) - 1) ||
            dateObject.getUTCDate() !== parseInt(day)) {
            console.error("A data original ('" + dateString + "') é inválida.");
            return ''; // Retorna string vazia ou trata o erro
        }
    
    
        // Converte o objeto Date para a string ISO 8601 (ex: "2025-02-28T00:00:00.000Z")
        return dateObject.toISOString();
    };
    const { setFeedback } = useContext(FeedbackContext)
    const { setTabIndex } = useOutletContext<RouterOutletType>()
    const navigate = useNavigate() 
    const { routerSection, setRouterSection } = useContext(SectionContext)
    const [test, setTest] = useState(false);
    const {router, setRouter} = useContext(RouterContext)
    const [freightSelected, setFreightSelected] = useState<number[]>([])
    const [orderedFreights, setOrderedFreights] = useState<FreightItem[]>([])
    const [addressFreight, setAddressFreight] = useState<string[]>([])
    const [freights, setFreights] = useState<FreightItem[]>([])
    const [url, setUrl] = useState('https://www.google.com.br/maps?q=06278-010,%20Brasil&output=embed')
    const [date, setDate] = useState(dataFormatter(router?.date || '')  )
    const [selectedVehicle, setSelectedVehicle] = useState<string>(router?.vehicle?.plate || 'Selecione...');
    const [vehicles, setVehicles] = useState<any[]>([]);
    const [companyDestination, setCompanyDestination] = useState<boolean>(router?.companyDestination || true);
    const [duplicateBlocker, setDuplicateBlocker] = useState<boolean>(false)

    const initialWaypoints = useMemo(() => {
        return [];
    }, []);
    const [waypoints, setWayPoints] = useState<Waypoints[]>(initialWaypoints)
    const {routerInfo, setRouterInfo} = useContext(RouterInfoContext)
    
    // Drag and drop sensors
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 8,
            },
        }),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    const handleChange = (value: string) => {
        const digits = value.replace(/\D/g, '');
        let formatted = '';
        if (digits.length > 0) {
            formatted += digits.substring(0, Math.min(2, digits.length));
            if (digits.length > 2) {
                formatted += '/' + digits.substring(2, Math.min(4, digits.length));
                if (digits.length > 4) {
                    formatted += '/' + digits.substring(4, Math.min(8, digits.length));
                }
            }
        }
        setDate(formatted)
    }

    // Handle drag end for reordering
    const handleDragEnd = (event: DragEndEvent) => {
        const { active, over } = event;

        if (!over || active.id === over.id) {
            return;
        }

        const activeIndex = orderedFreights.findIndex(freight => freight.id.toString() === active.id);
        const overIndex = orderedFreights.findIndex(freight => freight.id.toString() === over.id);

        if (activeIndex !== -1 && overIndex !== -1) {
            const newOrderedFreights = arrayMove(orderedFreights, activeIndex, overIndex);
            setOrderedFreights(newOrderedFreights);
            
            // Update waypoints to match new order
            const newWaypoints = newOrderedFreights.map(freight => ({
                location: `${freight.address.street}, ${freight.address.number} - ${freight.address.neighborhood.city.name}/${freight.address.neighborhood.city.state.uf}`,
                stopover: true
            }));
            setWayPoints(newWaypoints);
        }
    };
   
    const postRouter = async () => {
        setDuplicateBlocker(true)
        try{
            const body = {
                date : dataFormatterISO(date),
                status: "A programar",
                freightIds: orderedFreights.map((freight)=>freight.id),
                track: routerInfo?.track,
                companyDestination: companyDestination,
                url: routerInfo?.url || 'https://www.google.com.br/maps?q=06278-010,%20Brasil&output=embed',
                origin: router?.origin || 'vendas',
                vehicleId: Number(selectedVehicle)
            }
           
            const response = await axios.post(`${process.env.REACT_APP_ROUTER_BASE_URL}/route`, body);
            console.log(routerInfo?.url)

            setFeedback({
                isOpen:true,
                message:'Rota criada com sucesso!',
                statusOk:true
              })
              setDuplicateBlocker(false)
            setRouterSection('routers')
            navigate('/panel/router/routers')
           
        }catch{
            setFeedback({
                isOpen:true,
                message:'Erro ao criar rota!',
                statusOk:false
              })
              setDuplicateBlocker(false)
        }
        
    }

    const putRouter = async () => {
        setDuplicateBlocker(true)
        try{
            const body = {
                id: router?.id,
                date : dataFormatterISO(date),
                status: "A programar",
                freightIds: orderedFreights.map((freight)=>freight.id),
                companyDestination: companyDestination,
                track: routerInfo?.track,
                url: routerInfo?.url,
                origin: router?.origin || 'vendas',
                vehicleId: Number(selectedVehicle)
            }
            console.log(body)
            const response = await axios.put(`${process.env.REACT_APP_ROUTER_BASE_URL}/route`, body);
            console.log(response.data)
            setRouter(null)
            setRouterSection('routers')
            navigate('/panel/router/routers')
            setFeedback({
                isOpen:true,
                message:'Rota atualizada com sucesso!',
                statusOk:true
              })
              setDuplicateBlocker(false)
        }catch{
            setFeedback({
                isOpen:true,
                message:'Erro ao atualizar rota!',
                statusOk:false
              })
              setDuplicateBlocker(false)
        }
        
    }

    const updateFreigth = (id: number, freight: FreightItem) => {
        if(freightSelected.includes(id)) {
            setFreightSelected(freightSelected.filter(freightId => freightId !== id));
            
            setOrderedFreights(orderedFreights.filter(item => item.id !== id));
            setFreights([...freights, freight])
            setWayPoints(waypoints.filter(wayPoint => 
                wayPoint.location !== `${freight.address.street}, ${freight.address.number} - ${freight.address.neighborhood.city.name}/${freight.address.neighborhood.city.state.uf}`
            ));
        } else {
            setFreightSelected([...freightSelected, id]);
            setOrderedFreights([...orderedFreights, freight]);
            setFreights(freights.filter(item=> item.id !==id))
            const newAddress = `${freight.address.street}, ${freight.address.number} - ${freight.address.neighborhood.city.name}/${freight.address.neighborhood.city.state.uf}`;
            setWayPoints([...waypoints, { location: newAddress, stopover: true }]);
        }
    }
    
    const handleVehicle = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newVehicle = e.target.value;
        if(newVehicle === selectedVehicle){
            setSelectedVehicle("");
        }else{
            setSelectedVehicle(newVehicle);
        }
    }

    useEffect(() => {
        const getFreights = async () => {
            const url =  `${process.env.REACT_APP_ROUTER_BASE_URL}/freight/route/${0}`
            const response = await axios.get(url);
            console.log(url)
            setFreights(response.data);
        }

        const getVehicles = async () => {
            const response = await axios.get(`${process.env.REACT_APP_ROUTER_BASE_URL}/vehicle`);
            setVehicles(response.data);
        }

        getVehicles()
        getFreights()
    }, [])

    useEffect(() => {
        if(router){
            setFreightSelected(router.freight.map((freight: FreightItem) => freight.id));
            setOrderedFreights(router.freight);
            console.log(router)
            setDate(dataFormatter(router.date))
            if (router.companyDestination !== undefined) {
                setCompanyDestination(router.companyDestination);
            }
            setWayPoints(router.freight.map((freight: FreightItem) => {
                return {
                    location: `${freight.address.street}, ${freight.address.number} - ${freight.address.neighborhood.city.name}/${freight.address.neighborhood.city.state.uf}`,
                    stopover: true
                }
            }))
        }
    },[router?.id])

    const Maps = useMemo(() => {
        const MapsComponent: React.FC = () => {
            const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
            const defaultCenter = { lat: -23.473030452297433, lng: -46.78039101579958 };
            const defaultZoom = 11;
            const initialMarkers = [
                { lat: -23.56, lng: -46.65 }, 
                { lat: -23.54, lng: -46.62 },
            ];

            if (!googleMapsApiKey) {
                throw new Error('Google Maps API key is not set');
            }

            return (
                <div style={{ width: '100%', height: '100%'}}>
                    <MyMap
                        apiKey={googleMapsApiKey}
                        center={defaultCenter}
                        zoom={defaultZoom}
                        markers={initialMarkers}
                        wayPoints={waypoints}
                        companyDestination={companyDestination}
                    />
                </div>
            );
        };
        
        return <MapsComponent />;
    }, [waypoints, companyDestination]);
    
    return (
        <>
        
        {/* <ContainerHeader>
            <BigText>Novo roteiro:</BigText>
            <OptionsDiv>
                        <ButtonOfSection onClick={() => router ? putRouter() : postRouter()}>
                            <ButtonOfSectionText>{router ? 'Atualizar roteiro' : 'Criar roteiro'}</ButtonOfSectionText>
                        </ButtonOfSection>
                    </OptionsDiv>
        </ContainerHeader> */}
        
        <DivComponents style={{border: ''}}>
            <OptionsDiv className="reverse">
                <StyledLink onClick={() => {
                    setRouterSection('routers')
                    // setTabIndex(1)
                    navigate('/panel/router/routers')
                    setRouter(null);
                }} className="linkMode">Roteiros e fretes</StyledLink>
                <StyledLink style={{ marginLeft: '0.3rem' }}> {router?.id ? '> Editar roteiro' : '> Novo roteiro'}</StyledLink>
            </OptionsDiv>
            <Container>
                <FormContainer>
                    <InputDiv>
                        <InputLabel>Veículo</InputLabel>
                        <SelectData value={selectedVehicle || (router?.vehicle?.id || 'Teste')} onChange={handleVehicle}>
                             <StyledOption value={router?.vehicle?.id || ''} >{ router?.vehicle?.plate || 'Selecione..'}</StyledOption>
                            {vehicles.map((vehicle) => (
                                <StyledOption key={vehicle.id} value={vehicle.id} >
                                    {vehicle.plate}
                                </StyledOption>
                            ))}
                        </SelectData>
                    </InputDiv>

                    <InputDiv>
                        <InputLabel>Data</InputLabel>
                        <StyledDate placeholder="DD/MM/AAAA" value={date || ''} onChange={(e) => handleChange(e.target.value)}></StyledDate>
                    </InputDiv>
                            <InputDiv>
                    <SwitchDiv>
                  
                        <InputLabel>Destino da empresa (Dustre)</InputLabel>
                                    <SwitchBox>
                                        <SwitchInput
                                            type="checkbox"
                                            onClick={() => setCompanyDestination(!companyDestination)}
                                            checked={companyDestination} />
                                        <SwitchSlider className="slider"></SwitchSlider>
                                    </SwitchBox>
                                </SwitchDiv>
                                </InputDiv>
                    <InputDiv>
                    <div style={{display: 'flex'}}>
                    <InputLabel>Frete</InputLabel> 
                    <p style={{fontSize: '12px', color: '#0091d4', backgroundColor: '#e5e7eb', padding: '2px 8px ', borderRadius: '12px', fontWeight: "bold", marginLeft: '0.5rem'}}>{routerInfo?.track }</p>
                    </div>
                       
                        <StyledSearch placeholder="Selecione..."></StyledSearch>
                    </InputDiv>
                    
                    <OptionsContainer>
                        {/* Selected Freights Section with Drag and Drop */}
                        {orderedFreights.length > 0 && (
                            <div style={{ marginBottom: '16px' }}>
                                <div style={{ 
                                    fontSize: '14px', 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    marginBottom: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    Fretes Selecionados ({orderedFreights.length}) 
                                    {/* <span style={{ 
                                        fontSize: '12px', 
                                        color: '#6b7280', 
                                        backgroundColor: '#e5e7eb', 
                                        padding: '2px 8px', 
                                        borderRadius: '12px' 
                                    }}>
                                        Arraste para reordenar
                                    </span> */}
                                </div>
                                
                                <DndContext
                                    sensors={sensors}
                                    collisionDetection={closestCenter}
                                    onDragEnd={handleDragEnd}
                                    modifiers={[restrictToVerticalAxis, restrictToParentElement]}
                                >
                                    <SortableContext 
                                        items={orderedFreights.map(f => f.id.toString())} 
                                        strategy={verticalListSortingStrategy}
                                    >
                                        {orderedFreights.map((freight) => (
                                            <DraggableFreightItem
                                                key={freight.id}
                                                freight={freight}
                                                onSelect={updateFreigth}
                                            />
                                        ))}
                                    </SortableContext>
                                </DndContext>
                            </div>
                        )}

                        {/* Available Freights Section */}
                        {freights.length > 0 && (
                            <div>
                                {orderedFreights.length > 0 && (
                                    <div style={{ 
                                        fontSize: '14px', 
                                        fontWeight: '600', 
                                        color: '#374151', 
                                        marginBottom: '8px' 
                                    }}>
                                        Fretes Disponíveis
                                    </div>
                                )}
                                
                                {freights.map((freight: FreightItem) => {
                                    if (!freightSelected.includes(freight.id)) {
                                        return (
                                            <StyledFreight key={`available-${freight.id}`} onClick={() => updateFreigth(freight.id, freight)}>
                                                <StyledChecklistContainer><StyledCheckList className={freightSelected.includes(freight.id) ? 'selected' : ''} /></StyledChecklistContainer>
                                                <FreightInfo>
                                                    <StyledFreightText title={freight.company.companyName}>{freight.company.companyName.split(/\s|-/).slice(0, 2).join(' ') + '...'}</StyledFreightText>
                                                    <StyledFreightSubText>
                                                        {`${freight.address.street}, ${freight.address.number} - ${freight.address.neighborhood.city.name}/${freight.address.neighborhood.city.state.uf}`}
                                                    </StyledFreightSubText>
                                                </FreightInfo>
                                            </StyledFreight>
                                        );
                                    }
                                    return null;
                                })}
                            </div>
                        )}
                    </OptionsContainer>
                </FormContainer>
                <div style={{width:'100%', paddingBottom: '4rem'}}> {/**Solução temporaria */}
                <IframeContainer>
                    
                    {Maps}
                    
                </IframeContainer>
                <ButtonContainer style={{marginTop: '0.5rem', marginBottom: '0.5rem'}}>
                    {duplicateBlocker ? 
                        <ButtonCreate className="disable">Aguarde</ButtonCreate>
                        :
                    <ButtonCreate onClick={()=>router? putRouter():postRouter()}> <img style={{width: '1.5rem', height: '1.5rem'}} src={save}/>Salvar Rota</ButtonCreate>
                    }
                
                </ButtonContainer>
                </div>
            </Container>
           
            </DivComponents>
           
        </>
    )
}

export default NewRouter